import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import {
  Product,
  ProductResponse,
  ProductsResponse,
} from "src/app/_models/interfaces";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { RequestsService } from "src/app/_shared/services/requests.service";
import {
  AgrishopSummary,
  AvailablePackages,
  ICategory,
  ICategoryResponse,
  Sku,
} from "../agrishop.interface";

@Injectable({
  providedIn: "root",
})
export class AgrishopService {
  totals: BehaviorSubject<AgrishopSummary> = new BehaviorSubject({
    intransit: 0,
    today: 0,
    new: 0,
    trash: 0,
    delivered: 0,
    delivery: 0,
    confirmed: 0,
    packages: 0,
    stock: 0,
    purchaseList: 0,
    all: 0,
    purchaseOrders: 0,
    failed: 0,
    readyForDelivery: 0,
  });
  categories = new BehaviorSubject<ICategory[]>([]);
  constructor(
    private requestService: RequestsService,
    private authenticationService: AuthenticationService
  ) {}

  getTotals(list: [{ status: string; total: number }]) {
    const obj = new Object() as AgrishopSummary;
    const tabs = {
      packages: "packing",
      delivered: "complete",
      trash: "DELETED",
      confirmed: "confirmed",
      today: "today",
      new: "pending",
      new_old_app: "pending confirmation",
      stock: "stock",
      all: "all",
      failed: "failed",
      intransit: "intransit",
      Intransit: "Intransit",
      purchaseList: "not_purchased",
      purchaseOrders: "purchase_orders",
    };
    Object.keys(tabs).forEach((key) => {
      const val = list.find((val) => val.status === tabs[key]);
      obj[key] = val ? val.total : 0;
    });
    const intransit = obj["intransit"] + obj["Intransit"];
    obj["delivery"] =
      obj["delivered"] + obj["failed"] + obj["packages"] + intransit;
    obj["new"] += obj["new_old_app"];
    obj["readyForDelivery"] = intransit + obj["packages"];
    return obj;
  }

  getAgrishopSummary() {
    let salt = Math.round(Date.now() / 1000) * 1000;
    return this.requestService
      .dash_get3(`input_orders/order_totals?salt=${salt}`, null, true)
      .pipe(
        tap((res) => {
          // console.log("Here");
          console.log(res);
          // this.totals.next(this.getTotals(res.data));
          this.totals.next(res.data);
        })
      );
  }

  getInputs(params: string): Observable<ProductsResponse> {
    // return this.requestService.dash_get(`inputs?${params}`, null, true);
    return this.requestService.dashboard_fetch(
      `agrishop/fetch_products?`,
      params
    );
  }

  getInputById(id: string): Observable<ProductResponse> {
    return this.requestService.dash_get(`inputs/${id}`, null, true);
  }

  patchInput(id: string, data: Partial<Product>): Observable<ProductResponse> {
    return this.requestService.dash_patch(`inputs/${id}`, data, true);
  }

  createInput(data: Partial<Product>): Observable<ProductResponse> {
    return this.requestService.dash_post(`inputs`, data, true);
  }
  updateInput(id: string, data: Partial<Product>): Observable<ProductResponse> {
    return this.requestService.dash_put(`inputs/${id}`, data, true);
  }

  getCategories(params: string): Observable<ICategoryResponse> {
    return this.requestService
      .dash_get3(`input_categories/fetch_categories?${params}`, null, true)
      .pipe(
        tap((res) => {
          this.categories.next(res.data);
        })
      );
  }

  updateCategory(
    id: string,
    data: Partial<ICategory>
  ): Observable<ICategoryResponse> {
    return this.requestService
      .dash_put(`inputs/category/${id}`, data, true)
      .pipe(
        tap((res) => {
          // find category and update it
          const index = this.categories.value.findIndex(
            (category) => category.id === id
          );
          this.categories.value[index] = res.data;
          this.categories.next(this.categories.value);
        })
      );
  }

  deleteCategory(id: string) {
    return this.requestService.dash_delete(id, `inputs/category`, true).pipe(
      map((res) => res.data as ICategory),
      tap((res) => {
        const index = this.categories.value.findIndex(
          (category) => category.id === id
        );
        this.categories.value.splice(index, 1);
        this.categories.next(this.categories.value);
      })
    );
  }

  createCategory(data: Partial<ICategory>): Observable<ICategory> {
    return this.requestService.dash_post(`inputs/category`, data, true).pipe(
      map((res) => res.data),
      tap((res) => {
        this.categories.next([...this.categories.value, res]);
      })
    );
  }

  public get categories$(): Observable<ICategory[]> {
    return this.categories.asObservable();
  }

  public getCategoryById(id: string): Observable<ICategory> {
    return this.categories.pipe(
      map((categories) => {
        return categories.find((category) => category.id === id);
      })
    );
  }

  getavailablePackages(): Observable<AvailablePackages[]> {
    return this.requestService
      .dash_get(`inputs/units`, null, true)
      .pipe(map((res) => res.data.data));
  }

  getSkus(): Observable<Sku[]> {
    return this.requestService
      .dash_get(`inputs/skus`, null, true)
      .pipe(map((res) => res.data));
  }

  getCrops() {
    const currentUser = this.authenticationService.getCurrentUserValue();
    const { country } = currentUser;
    return this.requestService.dash_get(
      `inputs/crops?country=${country}`,
      null,
      true
    );
  }
}
